export default __webpack_public_path__ + "static/media/MessinaSans-Bold.061560d6.woff2";